// eslint-disable-next-line import/no-cycle
import {
  GET_BENEFACTORS,
  GET_MY_BENEFACTORS,
  BENEFACTORS,
  MY_BENEFACTORS,
  BENEFACTOR_ERROR,
  BENEFACTOR_SUCCESS,
  CREATE_BENEFACTOR,
} from 'redux/actions';


export const getBenefactors = (filter) => {
  return {
    type: GET_BENEFACTORS,
    payload: filter,
  };
};

export const getMyBenefactors = (filter) => {
  return {
    type: GET_MY_BENEFACTORS,
    payload: filter,
  };
};

export const createBenefactor = (benefactor, callback) => {
  return {
    type: CREATE_BENEFACTOR,
    payload: { benefactor, callback },
  };
};

export const benefactors = ({ benefactors }) => {
  return {
    type: BENEFACTORS,
    payload: { benefactors },
  };
};

export const myBenefactors = ({ benefactors }) => {
  return {
    type: MY_BENEFACTORS,
    payload: { benefactors },
  };
};

export const benefactorSuccess = (message) => ({
  type: BENEFACTOR_SUCCESS,
  payload: { message },
});
export const benefactorError = (message) => ({
  type: BENEFACTOR_ERROR,
  payload: { message },
});
